/**
 * Step definitions for front and back sides of the card
 */
export const STEPS = {
    front: [
        {
            id: 'background_color',
            title: 'Background Color',
            required: false,
            type: 'color',
            description: 'Modify the color of the background',
            order: 0,
            elements: ['background'],
            allowedActions: ['color'],
            startHidden: false,
            optional: true
        },
        {
            id: 'name',
            title: 'Your Name',
            required: true,
            type: 'text',
            description: 'Add your name to the card',
            order: 1,
            elements: ['client_name'],
            allowedActions: ['scale', 'font', 'color','move']
        },
        {
            id: 'team_name',
            title: 'Your Team Name',
            required: true,
            type: 'text',
            description: 'Add your team name to the card',
            order: 2,
            elements: ['team_name'],
            allowedActions: ['scale', 'font', 'color','move']
        },
        {
            id: 'text_line_one',
            title: 'Text Line One',
            required: false,
            type: 'text',
            description: 'Add a custom text line to the card',
            order: 2,
            elements: ['text_line_one'],
            allowedActions: ['scale', 'font', 'color','move'],
            forceCreation: true
        },
        {
            id: 'logo',
            title: 'Your Logo',
            required: false,
            type: 'image',
            description: 'Upload your team or personal logo',
            order: 3,
            elements: ['client_logo'],
            allowedActions: ['scale','move']
        },
        {
            id: 'front_backimagesmoke',
            title: 'Back Smoke Effect',
            required: false,
            type: 'color',
            description: 'Modify the color of the smoke behind your image',
            order: 5,
            elements: ['backsmoke'],
            allowedActions: ['color','move','scale'],
            startHidden: false,
            optional: true
        },
        {
            id: 'image',
            title: 'Your Image',
            required: true,
            type: 'image',
            description: 'Upload your personal image',
            order: 4,
            elements: ['client_image'],
            allowedActions: ['scale', 'move'],
            startHidden: true,
            needsBackgroundRemoval: true,
            backgroundRemovalInfo: {
                title: 'Professional Background Removal',
                description: 'We\'ll professionally remove the background from your image during production. Turn this off only if your image already has a transparent background.',
                showNotification: true
            }
        },
        {
            id: 'smoke',
            title: 'Smoke Effect',
            required: false,
            type: 'color',
            description: 'Modify the color of the smoke',
            order: 5,
            elements: ['smoke'],
            allowedActions: ['color','move','scale'],
            startHidden: false,
            optional: true
        },
        {
            id: 'smoke2',
            title: 'Smoke Effect 2',
            required: false,
            type: 'color',
            description: 'Modify the color of the second smoke',
            order: 6,
            elements: ['smoke2'],
            allowedActions: ['color','move','scale'],
            startHidden: false,
            optional: true
        },
        {
            id: 'number',
            title: 'Your Number',
            type: 'text',
            description: 'Add your player number',
            order: 7,
            elements: ['team_number'],
            allowedActions: ['scale', 'font', 'color','move'],
            optional: true,
            required: false,
        },
        {
            id: 'sign',
            title: 'Personal Signature',
            type: 'signature',
            description: 'Add your personal signature',
            order: 8,
            elements: ['sign_background'],
            allowedActions: ['scale', 'move'],
            optional: true
        },
        {
            id: 'border',
            title: 'Main Border Color',
            type: 'color',
            description: 'Choose your main border color',
            order: 9,
            elements: ['border'],
            allowedActions: ['color'],
            optional: true
        },
        {
            id: 'border2',
            title: 'Secondary Border Color',
            type: 'color',
            description: 'Choose your secondary border color',
            order: 10,
            elements: ['border2'],
            allowedActions: ['color'],
            optional: true
        },
        {
            id: 'border3',
            title: 'Outline Border Color',
            type: 'color',
            description: 'Choose your outline border color',
            order: 11,
            elements: ['border3'],
            allowedActions: ['color'],
            optional: true
        },
        {
            id: 'effects',
            title: 'Effects',
            type: 'effects',
            price: 3.00,
            description: 'Add special effects',
            order: 12,
            targets: ['user_image_placeholder', 'background_user'], // Target elements this applies to
            options: [
                {
                    id: 'cracked_ice',
                    title: 'Cracked Ice',
                    src: 'effects/cracked_ice.jpg'
                },
                {
                    id: 'stars',
                    title: 'Stars',
                    src: 'effects/stars.png'
                },
                {
                    id: 'disco',
                    title: 'Disco',
                    src: 'effects/disco.png'
                }
            ]
        },
        {
            id: 'patch',
            title: 'Jersey or Ball Patch',
            type: 'select',
            price: 3.00,
            description: 'Add any colored jersey or sports ball patch',
            order: 13,
            elements: ['texture_patch'],
            allowedActions: ['move'],
            shapes: [  // Shape options
                {
                    id: 'rectangle',
                    title: 'Rectangle',
                    dimensions: { width: 23.75, height: 18 }, // in mm
                    type: 'rect'
                },
                {
                    id: 'square',
                    title: 'Square',
                    dimensions: { width: 14.25, height: 14.25 }, // in mm
                    type: 'rect'
                },
                {
                    id: 'circle',
                    title: 'Circle',
                    dimensions: { radius: 9.5 }, // in mm (radius)
                    type: 'circle'
                }
            ],
            // Grouped options with categories
            optionGroups: [
                {
                    id: 'sports',
                    title: 'Ball Patch',
                    options: [
                        {
                            id: 'american_ball',
                            title: 'Football',
                            src: 'patches/americanball.jpg'
                        },
                        {
                            id: 'basket_ball',
                            title: 'Basket Ball',
                            src: 'patches/basketball.jpg'
                        },
                        {
                            id: 'soccer_ball',
                            title: 'Soccer Ball',
                            src: 'patches/soccerball.jpg'
                        },
                        {
                            id: 'baseball',
                            title: 'Baseball',
                            src: 'patches/baseball.jpg'
                        },
                        {
                            id: 'tennis_ball',
                            title: 'Tennis Ball',
                            src: 'patches/tenisball.jpg'
                        },
                        {
                            id: 'volleyball',
                            title: 'Volleyball',
                            src: 'patches/volleyball.jpg'
                        }
                    ]
                },
                {
                    id: 'jerseys',
                    title: 'Jersey Patch',
                    options: [
                        {
                            id: 'babyblue_jersey',
                            title: 'Baby Blue',
                            src: 'patches/babyblue_jersey.jpg'
                        },
                        {
                            id: 'black',
                            title: 'Black',
                            src: 'patches/black_jersey.jpg'
                        },
                        {
                            id: 'gold_jersey',
                            title: 'Gold',
                            src: 'patches/gold_jersey.jpg'
                        },
                        {
                            id: 'gray_jersey',
                            title: 'Gray',
                            src: 'patches/gray_jersey.jpg'
                        },
                        {
                            id: 'green_jersey',
                            title: 'Green',
                            src: 'patches/green_jersey.jpg'
                        },
                        {
                            id: 'camou_jersey',
                            title: 'Camo',
                            src: 'patches/camou_jersey.jpg'
                        },
                        {
                            id: 'navyblue_jersey',
                            title: 'Navy Blue',
                            src: 'patches/navyblue_jersey.jpg'
                        },
                        {
                            id: 'orange_jersey',
                            title: 'Orange',
                            src: 'patches/orange_jersey.jpg'
                        },
                        {
                            id: 'pink_jersey',
                            title: 'Pink',
                            src: 'patches/pink_jersey.jpg'
                        },
                        {
                            id: 'purple_jersey',
                            title: 'Purple',
                            src: 'patches/purple_jersey.jpg'
                        },
                        {
                            id: 'red',
                            title: 'Red',
                            src: 'patches/red_jersey.jpg'
                        },
                        {
                            id: 'white_jersey',
                            title: 'White',
                            src: 'patches/white_jersey.jpg'
                        },
                        {
                            id: 'yellow_jersey',
                            title: 'Yellow',
                            src: 'patches/yellow_jersey.jpg'
                        }
                    ]
                }
            ],
        },
        {
            id: 'card_number',
            title: 'Number Your Card',
            type: 'card_number',
            description: 'One Of One logo',
            order: 14,
            elements: ['card_number'],
            allowedActions: ['move'],
            optional: true
        },
        {
            id: 'ai',
            title: 'Avatar AI',
            type: 'toggle',
            price: 3.00,
            description: 'Convert image with AI',
            order: 15,
            info: {
                title: 'AI Image Transformation',
                description: 'Our advanced AI technology transforms your photo into a professional sports card style. This gives your card a unique, artistic look that stands out.',
                imageSrc: '/examples/ai-transformation-example.webp',
                position: 'right'
            }
        },
        {
            id: 'slab',
            title: 'Grading Slab',
            type: 'slab',
            price: 10.00,
            description: 'Add a professional grading slab',
            order: 16,
            required: false
        }
    ],
    back: [
        {
            id: 'background_color',
            title: 'Background Color',
            required: false,
            type: 'color',
            description: 'Modify the color of the background',
            order: 0,
            elements: ['back_background'],
            allowedActions: ['color'],
            optional: true
        },
        {
            id: 'custom_back_image',
            title: 'Additional Image',
            type: 'image',
            description: 'Add an image to the back of the card',
            order: 1,
            elements: [],
            allowedActions: ['scale', 'move'],
            required: false,
            startHidden: false,
        },
        {
            id: 'multi_text',
            title: 'Custom Text Fields',
            type: 'multi_text',
            description: 'Add up to 5 custom text fields',
            order: 2,
            elements: ['multi_text_back'],
            allowedActions: ['scale', 'font', 'color', 'move'],
            maxFields: 5,
            required: false
        },
        {
            id: 'back_qrcode',
            title: 'QR Code',
            type: 'qrcode',
            price: 5.00,
            description: 'Add scannable QR code',
            order: 3,
            elements: [], // Can be empty or include a placeholder
            allowedActions: ['scale', 'move'],
            required: false
        },
        {
            id: 'name',
            title: 'Your Name',
            required: false,
            type: 'text',
            description: 'Add your name to the card',
            order: 4,
            elements: ['back_client_name'],
            allowedActions: ['scale', 'font', 'color','move'],
            optional: true
        },
        {
            id: 'team_name',
            title: 'Your Team Name',
            required: false,
            type: 'text',
            description: 'Add your team name to the card',
            order: 5,
            elements: ['back_team_name'],
            allowedActions: ['scale', 'font', 'color','move'],
            optional: true
        },
        {
            id: 'logo',
            title: 'Your Logo',
            required: false,
            type: 'image',
            description: 'Upload your team or personal logo',
            order: 6,
            elements: ['back_client_logo'],
            allowedActions: ['scale','move'],
            optional: true,
            startHidden: false,
        },
        {
            id: 'image',
            title: 'Your Image',
            required: false,
            type: 'image',
            description: 'Upload your profile picture',
            order: 7,
            elements: ['back_client_image'],
            allowedActions: ['scale', 'move'],
            startHidden: true,
            optional: true
        },
        {
            id: 'back_smoke',
            title: 'Smoke Effect',
            required: false,
            type: 'color',
            description: 'Modify the color of the smoke',
            order: 8,
            elements: ['back_smoke'],
            allowedActions: ['color','move','scale'],
            startHidden: true,
            optional: true
        },
        {
            id: 'number',
            title: 'Your Number',
            type: 'text',
            description: 'Add your player number',
            order: 9,
            elements: ['back_team_number'],
            allowedActions: ['scale', 'font', 'color','move'],
            optional: true
        },
        {
            id: 'border',
            title: 'Border Color',
            type: 'color',
            description: 'Choose your border color',
            order: 10,
            elements: ['back_border'],
            allowedActions: ['color'],
            optional: true,
            startHidden: true,
        },
        {
            id: 'border2',
            title: 'Border Color 2',
            type: 'color',
            description: 'Choose your second border color',
            order: 11,
            elements: ['back_border2'],
            allowedActions: ['color'],
            required: false,
            optional: true,
            startHidden: true,
        },
        {
            id: 'border3',
            title: 'Border Color 3',
            type: 'color',
            description: 'Choose your third border color',
            order: 12,
            elements: ['back_border3'],
            allowedActions: ['color'],
            required: false,
            optional: true,
            startHidden: true,
        }
    ]
};